import { AlertTriangle, Clock, Ban, Info } from 'lucide-react';

const LEVEL_STYLES = {
  critical: { cls: 'bg-red-950/70 border-red-700 text-red-200', icon: Ban },
  high: { cls: 'bg-amber-950/70 border-amber-600 text-amber-200', icon: AlertTriangle },
  warning: { cls: 'bg-yellow-950/50 border-yellow-700/70 text-yellow-200', icon: Clock },
  info: { cls: 'bg-sky-950/60 border-sky-700 text-sky-200', icon: Info },
};

export function AccountWarningBanner({ warnings = [], className = '' }) {
  if (!warnings || warnings.length === 0) return null;
  return (
    <div className={`space-y-2 ${className}`} data-testid="account-warning-banner">
      {warnings.map((w, i) => {
        const style = LEVEL_STYLES[w.level] || LEVEL_STYLES.info;
        const Icon = style.icon;
        return (
          <div
            key={i}
            className={`flex items-center gap-3 rounded-lg border px-4 py-2.5 ${style.cls}`}
            data-testid={`account-warning-${w.level}`}
          >
            <Icon className="w-4 h-4 shrink-0" />
            <span className="font-['Inter'] text-sm">{w.message}</span>
          </div>
        );
      })}
    </div>
  );
}
